import { MenuOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Col, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
// import { logo } from "../../assets";
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
import Sidebar from "./sidebar";

type RootState = any;
function DesktopLayout({ children }: any) {
  const { modalOpened } = useSelector((state: RootState) => state.settings);
  const [chooseApp, setChooseApp] = useState(false);
  const history = useHistory();
  const permissions = JSON.parse(localStorage.getItem("persist:root") as any);
  const allPermissions = permissions && JSON.parse(permissions?.auth);
  const myPermissions = allPermissions?.applications;

  const dispatch = useDispatch();
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const [collapsed, setCollapsed] = useState(screenType?.desktop ? false : true);
  
  return (
    <Row
      style={{ height: "100vh" }}
      className={modalOpened ? "blur-effect" : ""}
    >
      <Col span={24}>
        <Layout style={{ height: "100vh" }}>
          <Sider
            trigger={screenType.mobile ? <MenuOutlined /> : null}
            collapsible
            collapsed={collapsed}
            collapsedWidth={screenType.mobile ? 0 : 80}
            width={220}
            className={"app-sidebar"}
            onCollapse={() => setCollapsed(!collapsed)}
            theme="light"
          >
            <Row>
              <Col span={24}>
                {!screenType.mobile &&
                  React.createElement(
                    collapsed ? MenuUnfoldOutlined : MenuUnfoldOutlined,
                    {
                      className: "trigger",
                      onClick: () => setCollapsed(!collapsed),
                    }
                  )}

                {!collapsed ? (
                  <img
                    alt="crmlogo"
                    src="https://d27zjjrd786p5a.cloudfront.net/medi-ui/logo/cipla.png"
                    width={"50%"}
                    style={
                      !screenType.mobile
                        ? { marginLeft: "-10px", marginTop: "-5px" }
                        : {
                            width: "70%",
                            marginTop: "10px",
                            marginLeft: "15%",
                          }
                    }
                  ></img>
                ) : (
                  ""
                )}
              </Col>
            </Row>

            <div className="mt20 sidebar-bg">
              <Sidebar />
            </div>
          </Sider>
          <Layout className="site-layout">
            <Content className="app-container">
              <Row>
                <Col span={24}>{children}</Col>
              </Row>
            </Content>
          </Layout>
        </Layout>
      </Col>
    </Row>
  );
}

export default DesktopLayout;
